import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('loading');
  const navigate = useNavigate();

  useEffect(() => {
    async function init() {
      // Önce query params bak (token_hash yöntemi)
      const searchParams = new URLSearchParams(window.location.search);
      const tokenHash = searchParams.get('token_hash');
      const type = searchParams.get('type');

      if (tokenHash && type === 'recovery') {
        const { error } = await supabase.auth.verifyOtp({
          token_hash: tokenHash,
          type: 'recovery'
        });
        if (error) {
          setStatus('error');
        } else {
          window.history.replaceState(null, '', '/reset-password');
          setStatus('ready');
        }
        return;
      }

      // Hash'ten access_token bak (eski yöntem fallback)
      const hash = window.location.hash;
      if (hash) {
        const params = new URLSearchParams(hash.replace('#', ''));
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token') || '';
        const hashType = params.get('type');

        if (accessToken && hashType === 'recovery') {
          const { error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken
          });
          if (error) {
            setStatus('error');
          } else {
            window.history.replaceState(null, '', '/reset-password');
            setStatus('ready');
          }
          return;
        }
      }

      setStatus('error');
    }
    init();
  }, []);

  async function handleReset(e) {
    e.preventDefault();
    if (password !== confirm) { setError('Şifreler eşleşmiyor.'); return; }
    if (password.length < 6) { setError('Şifre en az 6 karakter olmalıdır.'); return; }
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.updateUser({ password });
    if (error) { setError(error.message); setLoading(false); }
    else {
      await supabase.auth.signOut();
      setSuccess(true);
      setLoading(false);
    }
  }

  if (success) return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={S.logo}>✅</div>
        <h2 style={S.title}>Şifreniz Güncellendi</h2>
        <p style={S.text}>Yeni şifrenizle giriş yapabilirsiniz.</p>
        <button style={S.button} onClick={() => navigate('/login')}>Giriş Yap</button>
      </div>
    </div>
  );

  if (status === 'error') return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={S.logo}>⚠️</div>
        <h2 style={S.title}>Bağlantı Geçersiz</h2>
        <p style={S.text}>Şifre sıfırlama bağlantısının süresi dolmuş olabilir. Lütfen tekrar talep edin.</p>
        <button style={S.button} onClick={() => navigate('/login')}>Giriş Sayfasına Dön</button>
      </div>
    </div>
  );

  if (status === 'loading') return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={S.logo}>⏳</div>
        <p style={{ textAlign: 'center', color: '#64748b' }}>Doğrulanıyor...</p>
      </div>
    </div>
  );

  return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={S.logo}>🔑</div>
        <h2 style={S.title}>Yeni Şifre Belirle</h2>
        <form onSubmit={handleReset}>
          <input style={S.input} type="password" placeholder="Yeni şifre (min. 6 karakter)" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />
          <input style={S.input} type="password" placeholder="Şifreyi tekrar girin" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={6} />
          {error && <p style={S.error}>{error}</p>}
          <button style={S.button} type="submit" disabled={loading}>
            {loading ? 'Güncelleniyor...' : 'Şifremi Güncelle'}
          </button>
        </form>
      </div>
    </div>
  );
}

const S = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f4f8' },
  card: { background: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' },
  logo: { textAlign: 'center', fontSize: '2.5rem', marginBottom: '0.75rem' },
  title: { textAlign: 'center', color: '#1e3a5f', marginBottom: '1rem', fontSize: '1.2rem', fontWeight: '700' },
  text: { textAlign: 'center', color: '#475569', marginBottom: '1.5rem', lineHeight: 1.6 },
  input: { width: '100%', padding: '0.75rem', marginBottom: '1rem', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '1rem', boxSizing: 'border-box' },
  button: { width: '100%', padding: '0.75rem', background: '#1e3a5f', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem', cursor: 'pointer' },
  error: { color: '#ef4444', marginBottom: '1rem', fontSize: '0.875rem' },
};
